import { render, staticRenderFns } from "./report-student.vue?vue&type=template&id=51ce6290"
import script from "./report-student.vue?vue&type=script&lang=js"
export * from "./report-student.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports